module.exports = "<div class=\"panel-group\">\r\n    <slot></slot>\r\n  </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Accordion.vue
 ** module id = 97
 ** module chunks = 0
 **/